<template>
  <div v-loading="quillUpdateImg" :id="'quill' + SGLKEY">
    <!-- 图片上传组件辅助-->
    <el-upload class="avatar-uploader" style="background-color: white; line-height: 0px"
      :action="abcd + '&id=' + this.user.userId" name="file" :headers="header" :show-file-list="false" list-type="picture"
      :multiple="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload"></el-upload>

    <el-upload class="avatar-uploader2" style="background-color: white; line-height: 0px" name="file" action=""
      :auto-upload="false" :show-file-list="false" :multiple="false" :on-change="beforeUpload2" :ref="'upload' + SGLKEY"></el-upload>
      <div >
        <quill-editor style="height: 500px" class="editor" v-model="content" :ref="'myQuillEditor'+ SGLKEY"  :options="editorOption"
      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)"></quill-editor>
      </div>

  </div>
</template>
<script>
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];
import base from "../../api/httpApi/base";
import { quillEditor, Quill } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import fileupload from "../../assets/backJs/util";
import Video from "@/quill/video";
import { v4 as uuidv4 } from "uuid";
Quill.register(Video, true);

export default {
  props: {
    /*编辑器的内容*/
    value: {
      type: String,
    },
    // SGLKEY: {
    //   type: String,
    //   default: 'All',
    // },
    imageType: {
      type: String,
      default: "topic",
    },
    /*图片大小*/
    maxSize: {
      type: Number,
      default: 4000, //kb
    },
    externalServerUrl: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    quillEditor,
  },

  data() {
    const that = this;
    return {
      user:  this.loginUser,
      SGLKEY: uuidv4(),
      content: this.value,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        theme: "snow", // or 'bubble'
        placeholder: "請輸入內容",
        modules: {
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  // console.log("#quill" + this.SGLKEY + " .avatar-uploader input");
                  document.querySelector("#quill" + that.SGLKEY + " .avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector("#quill" + that.SGLKEY + " .avatar-uploader2 input").click();
                }
              },
              link: function (value) {
                if (value) {
                  var href = prompt("请输入url");
                  // console.log(111111111, this.quill.format);
                  this.quill.format("link", href);
                } else {
                  this.quill.format("link", false);
                }
              },
            },
          },
        },
      },
      serverUrl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=${this.imageType}`, // 这里写你要上传的图片服务器地址
      header: {
        Authorization: "Bearer " + this.$store.state.permission.token,
      }, // 有的图片服务器要求请求头需要有token
    };
  },
  created() {
    this.user = this.loginUser;
    this.SGLKEY = uuidv4();
    // console.log(uuidv4());
  },
  mounted() {
    //this.content = `<h1></h1>`;
  },
  watch: {
    value(newval, oldval) {
      if (newval != oldval) {
        this.content = newval;
      }
    },
  },
  computed: {
    userid() { },
    abcd() {
      if (!this.externalServerUrl) {
        return `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=${this.imageType}`;
      } else {
        return `${base.dev}/TokenAuth/UploadBlog/Upload/UploadBlog?Type=${this.imageType}`;
      }
    },
  },
  methods: {
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
      this.$emit("input", this.content);
    },

    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },

    beforeUpload2(file) {
      if (
        [
          "video/mp4",
          "video/quicktime",
          "video/mpeg",
          "video/3gpp",
          "video/x-flv",
        ].indexOf(file.raw.type) == -1
      ) {
        this.$message.warning("請上傳正確的視頻格式");
        this.$refs["upload" + SGLKEY].clearFiles();
        return false;
      }
      this.getVideoMsg(file.raw)
        .then((res) => {
          this.fileHight = res.height;
          this.fileWidth = res.width;
          this.fileDuration = res.duration;
        })
        .then(() => {
          // let stort = JSON.parse(sessionStorage.getItem("store"));
          let userinfo = JSON.parse(localStorage.getItem("userinfo"));
          if (this.fileDuration > 60 && !userinfo.isAdmin) {
            this.$message.warning("視頻時間限制於1分鐘(60秒)內");
            this.$refs["upload" + SGLKEY].clearFiles();
          } else {
            this.quillUpdateImg = true;
            // console.log(this.quillUpdateImg);
            this.submitUpload(file.raw);
            this.$refs["upload" + SGLKEY].clearFiles();
          }
        });
    },
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", function () {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs["myQuillEditor" + this.SGLKEY].quill;
      // 如果上传成功
      // console.log(res);
      if (res.success == true) {
        // console.log(res.result);
        // 获取光标所在位置
        // console.log(quill.getSelection());
        let length = quill.getSelection() ? quill.getSelection().index : this.content.length ;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.result.url + "?" + this.getN());
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    uploadSuccess2(url) {
      let quill = this.$refs["myQuillEditor" + this.SGLKEY].quill;
      let length = quill.getSelection().index;
      quill.insertEmbed(length, "video", url);
      quill.setSelection(length + 1);
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    uploadError2() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("视频插入失败");
    },
    submitUpload(file) {
      fileupload.uploadFile(
        file, //视频文件
        this.loginUser.accessToken, //权限token
        this.loginUser.userId,
        (uploadsuccess) => {
          //上传成功的函数
          this.uploadunite(uploadsuccess);
        },
        (successfile) => {
          this.$refs["upload" + SGLKEY].clearFiles();
          this.uploadSuccess2(successfile.result.url);
        },
        (process) => {
          //进度回调函数
          // console.log({process});
          // if(process==100)
            // this.quillUpdateImg = false;
        },
        (failePage) => {
          //分片上傳時如果服務斷掉會進入這裏
          this.$message.error(failePage);
          this.$refs["upload" + SGLKEY].clearFiles();
          this.quillUpdateImg = false;
        }
      );
    },
    uploadunite(uploadsuccess) {
      //合并
      this.$api.VideoApi.uploadfileGather(uploadsuccess)
        .then((res) => {
          if (res.data.success == false) {
            this.$message.error(res.data.error.message);
            this.$refs["upload" + SGLKEY].clearFiles();
          } else {
            this.uploadSuccess2(res.data.result.url);
          }
          this.quillUpdateImg = false;
        })
        .catch((error) => {
          this.$message.error(error);
          this.quillUpdateImg = false;
        });
    },
  },
};
</script>

<style>
.editor {
  line-height: normal !important;
  height: 800px;
}

.ql-container.ql-snow {
  height: 90%;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-editor .ql-video {
  display: block !important;
  max-width: 100% !important;
  width: 640px !important;
  height: 400px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-align-center {
  text-align: center;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.el-form-item__content .el-loading-mask {
    z-index: 999!important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Editor.vue